<template>
  <div
    :class="[
      'c-nav-four-column-grid',
      'l-grid',
      'l-grid--4-col',
      'l-grid--4-col-min-2',
    ]"
  >
    <div
      v-for="item in navItems"
      :key="item.id"
    >
      <slot
        name="item"
        :item="item"
      >
        <component
          :is="item.contentType"
          v-if="item.contentType"
          :id="item.handle"
          v-bind="item.data"
        />
      </slot>
    </div>
  </div>
</template>

<script>
import ImageCardCta from "../card/ImageCardCta.vue";
export default {
  components: { ImageCardCta },
  props: {
    navItems: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.c-nav-four-column-grid {
  padding: rem(20px);
}
</style>
